export default {
    //正数，保留两位小数
    onlyNum: {
        inserted: function (el) {
            const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.addEventListener("input", function (e) {
                let val = ele.value;
                if (typeof val === 'string') {
                    val = val.replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
                    val = val.replace(/^\./g, ""); // 验证第一个字符是数字
                    val = val.replace(/^0{2,}/g, "0"); //若0开头，只保留一个0
                    val = val.replace(/^0\d*/g, '0');  //若0开头，0后只能是 "."
                    val = val.replace(/\.{2,}/g, "."); // 只保留第一个, 清除多余的
                    val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                    val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入2个小数
                    ele.value = val;
                }
            }, true)
        }
    },
    //>=0 正整数
    signInteger: {
        inserted: function (el) {
            const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.addEventListener("input", function (e) {
                let val = ele.value;
                if (typeof val === 'string') {
                    val = val.replace(/[^\d]/g, ""); // 清除"数字"以外的字符
                    val = val.replace(/^0{1,}/g, "0"); //若0开头，只能为0
                    val = val.replace(/^0\d*/g, '0');
                    ele.value = val;
                }
            }, true)
        }
    },
    loadTableMore: {
        bind(el, binding) {
            // 获取当前滚动的节点，注意必须要有高度
            const selectWrap = el.querySelector('.el-table__body-wrapper')
            if (selectWrap) {
                selectWrap.addEventListener('scroll', function (e) {
                    let sign = 3
                    // 这个sign值，只是为了滚动到最底部3px的时候加载
                    const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
                    if (Math.ceil(scrollDistance) <= sign) {
                        console.log(binding)
                        // 到这里 就会执行方法了
                        binding.value()
                    }
                })
            } else {
                console.log('没找到元素')
            }
        },
    },
}


// WEBPACK FOOTER //
// ./src/api/directive.js